export const Separator = () => {
  return <span className={"k-form-separator"} style={{ margin: "10px 0" }} />;
};
